import * as React from "react";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "@/lib/utils";

// shadcn's native-select (registry), on the portal's tokens: the field
// colours, border and focus ring of `input.tsx`. `className` styles the select;
// `wrapperClassName` the box around it (full width unless told otherwise).
function NativeSelect({
  className,
  wrapperClassName,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"select">, "size"> & { size?: "sm" | "default"; wrapperClassName?: string }) {
  return (
    <div
      className={cn("group/native-select relative w-full has-[select:disabled]:opacity-50", wrapperClassName)}
      data-slot="native-select-wrapper"
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          "w-full min-w-0 appearance-none rounded-[10px] border border-border bg-field py-[11px] pr-9 pl-[13px] text-sm text-foreground",
          "transition-[color,box-shadow,border-color] outline-none data-[size=sm]:py-[7px]",
          "focus-visible:border-brand focus-visible:ring-[3px] focus-visible:ring-ring",
          "disabled:pointer-events-none disabled:cursor-not-allowed",
          className,
        )}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-3.5 size-4 -translate-y-1/2 text-text-3 select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  );
}

function NativeSelectOption({ className, ...props }: React.ComponentProps<"option">) {
  return <option data-slot="native-select-option" className={cn("bg-[Canvas] text-[CanvasText]", className)} {...props} />;
}

function NativeSelectOptGroup({ className, ...props }: React.ComponentProps<"optgroup">) {
  return (
    <optgroup data-slot="native-select-optgroup" className={cn("bg-[Canvas] text-[CanvasText]", className)} {...props} />
  );
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
